import React, { useState, useEffect, useRef } from 'react';
import { CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';

const LabourBillCheckData = ({ fetchedData }) => {

  const totalQty = fetchedData.reduce((acc, item) => acc + item.QTY, 0);

  return (
    <div style={{ margin: '20px' }}>
      <h2 style={{ textAlign: 'center' }}>Labour Bill Detail's</h2>
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead style={{ position: 'sticky', top: 0, backgroundColor: '#e8e7e6' }}>
          <tr>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>Sr No.</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>TrDate</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>DCNo</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>Itcode</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>ItName</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>PartNo</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>ProcessCode</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>ProcessName</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>Qty</th>
            <th style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}>Rate</th>
          </tr>
        </thead>
        <tbody>
          {fetchedData.map((item, index) => {
            const formattedDate = new Date(item.TrDate).toLocaleDateString('en-CA');
            return (
              <tr key={index}>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{index + 1}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{formattedDate}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{item.DCNo}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{item.Itcode}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'left' }}>{item.ItName}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'left' }}>{item.PartNo}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{item.ProcessCode}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'left' }}>{item.ProcessName}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{item.QTY}</td>
                <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{item.Rate}</td>
              </tr>
            );
          })}
          <tr style={{ position: 'sticky', bottom: 0, backgroundColor: '#e8e7e6' }}>
            <td colSpan="8" style={{ padding: '4px', border: '1px solid #333', textAlign: 'right', fontWeight: 'bold' }}>Total Qty :</td>
            <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right', fontWeight: 'bold' }}>{totalQty}</td>
            <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'center' }}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LabourBillCheckData;
